import { Game } from './Game';

async function main(): Promise<void> {
  console.log('Starting Avoin Areena...');

  try {
    const game = new Game();
    await game.init();
    game.start();
  } catch (error) {
    console.error('Failed to start game:', error);
    // Display error on canvas
    const canvas = document.getElementById('game') as HTMLCanvasElement;
    if (canvas) {
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.fillStyle = '#c0c0c0';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#800000';
        ctx.font = 'bold 20px "comic sans ms"';
        ctx.textAlign = 'center';
        ctx.fillText('Failed to load game', canvas.width / 2, canvas.height / 2 - 20);
        ctx.font = '14px "comic sans ms"';
        ctx.fillText(
          error instanceof Error ? error.message : 'Unknown error',
          canvas.width / 2,
          canvas.height / 2 + 10
        );
      }
    }
  }
}

main();
